module.exports = __webpack_public_path__ + "static/media/ipad.20d7a6c5.jpg";